import React from "react";
import PropTypes from "prop-types";
import SVG from "components/base/SVG";

import css from "./style.scss";

function AddIcon({ onAddClick, title }) {
  return (
    <button onClick={onAddClick} className={css.transparentButton}>
      <div className={css.actionIcon}>
        <SVG icon={"add-inactive"} title={title} height={24} width={24} />
      </div>
    </button>
  );
}

AddIcon.propTypes = {
  onAddClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default AddIcon;

